import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
/*
 * transfer 穿梭框
 * author zhousheng
 */
import * as React from 'react';
import classnames from 'classnames';
import { ConfigContext } from '../config-provider';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
import DataSource from './DataSource';
import Target from './Target';
var Transfer = function Transfer(props) {
  var _classnames;
  var customizePrefixCls = props.prefixCls,
    className = props.className,
    _props$displayType = props.displayType,
    displayType = _props$displayType === void 0 ? 'single' : _props$displayType,
    targetKeys = props.targetKeys,
    onChange = props.onChange,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? {} : _props$locale,
    dataSource = props.dataSource;
  var _useLocaleReceiver = useLocaleReceiver('Transfer'),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
    transferLocale = _useLocaleReceiver2[0];
  var userLocale = _extends(_extends({}, transferLocale), locale);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  // 二级数据展开成一级数据
  var expansionSource = React.useMemo(function () {
    var expansionArr = [];
    dataSource.forEach(function (data) {
      if (!data.children || !data.children.length) {
        expansionArr.push(data);
        return;
      }
      var childrenKeys = [];
      expansionArr.push(_extends(_extends({}, data), {
        childrenKeys: childrenKeys,
        group: true,
        disabled: data.disabled || data.children.every(function (child) {
          return child.disabled;
        })
      }));
      data.children.forEach(function (child) {
        expansionArr.push(_extends(_extends({}, child), {
          groupKey: data.key,
          groupOption: true,
          disabled: data.disabled || child.disabled
        }));
        childrenKeys.push(child.key);
      });
    });
    return expansionArr;
  }, [dataSource]);
  var _React$useState3 = React.useState(targetKeys || []),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    tKeys = _React$useState4[0],
    setTKeys = _React$useState4[1];
  var mergedKeys = 'targetKeys' in props ? targetKeys : tKeys;
  React.useEffect(function () {
    onChange && onChange(tKeys);
  }, [tKeys]);
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls('transfer', customizePrefixCls);
  var classNames = classnames((_classnames = {}, _defineProperty(_classnames, prefixCls, true), _defineProperty(_classnames, className, className), _defineProperty(_classnames, "".concat(prefixCls, "-table"), displayType === 'table'), _classnames));
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement(DataSource, _extends({}, props, {
    displayType: displayType,
    locale: userLocale,
    prefixCls: prefixCls,
    tKeys: mergedKeys,
    setTKeys: setTKeys,
    loading: loading,
    setLoading: setLoading,
    expansionSource: expansionSource
  })), /*#__PURE__*/React.createElement(Target, _extends({}, props, {
    displayType: displayType,
    locale: userLocale,
    prefixCls: prefixCls,
    tKeys: mergedKeys,
    setTKeys: setTKeys,
    loading: loading,
    setLoading: setLoading,
    expansionSource: expansionSource
  })));
};
export default Transfer;